/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Loop_3_CmdInputs */

const en_mk_loop_3_cmd = /** @type {(inputs: Mk_Loop_3_CmdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`agent works`)
};

const id_mk_loop_3_cmd = /** @type {(inputs: Mk_Loop_3_CmdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`agent bekerja`)
};

/**
* | output |
* | --- |
* | "agent works" |
*
* @param {Mk_Loop_3_CmdInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_loop_3_cmd = /** @type {((inputs?: Mk_Loop_3_CmdInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Loop_3_CmdInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_loop_3_cmd(inputs)
	return en_mk_loop_3_cmd(inputs)
});